import React, {useState, useEffect} from "react";
import projectData from "./HomeComp/projectData";
import ProjectCard from "./HomeComp/projectCard";
import SyncLoader from "react-spinners/SyncLoader";

function UpcomingProjComp (){

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true) 
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }, [])

    return(
        <React.Fragment>

            {loading ? 
             
             <div className="animation_widget">
                 <SyncLoader 
                 loading={loading}
                 size={30} 
                 color = {"yellow"}
                  />
             </div>

             : 

             <div className="breadcrumb-area">
                <div>
                    <h1>Upcoming projects</h1>
                </div>
                <div className="project-widget">
                    {projectData.map((item) => <ProjectCard key={item.id} name={item.name} desc={item.desc} />)}
                </div>
            </div>

            }
        </React.Fragment>
    )
}

export default UpcomingProjComp;